import { render, staticRenderFns } from "./website-ten-years.vue?vue&type=template&id=2b643c8b&scoped=true&"
var script = {}
import style0 from "./website-ten-years.vue?vue&type=style&index=0&id=2b643c8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b643c8b",
  null
  
)

export default component.exports